import deleteShifts from "sh-stores/sh-shift-store/actions/deleteShifts";
import deleteShiftsInStore from "sh-stores/sh-shift-store/mutatorActions/deleteShiftsInStore";
import shiftsModified from "sh-stores/sh-shift-store/actions/shiftsModified";
import { MyShiftStore, ShiftStore, ShiftStoreSchema } from "..";
import { orchestrator } from "satcheljs";
import { ShiftStoreTypes } from "sh-application/../StaffHubConstants";
import schedulesViewStateStore from "../../../sh-application/components/schedules/lib/store/store";

export default orchestrator(deleteShifts, async actionMessage => {
    let shiftStoreEntity: ShiftStoreSchema;
    const store = actionMessage.viewState ? actionMessage.viewState : schedulesViewStateStore();
    actionMessage.shiftStoreType === ShiftStoreTypes.MyShiftStore ?
    shiftStoreEntity = MyShiftStore()
    :
    shiftStoreEntity = ShiftStore();

    // Delete the shifts from the Shift Store
    deleteShiftsInStore(actionMessage.shiftsDeleted, shiftStoreEntity);

    // Fire the shifts modified event so the UI knows to update
    shiftsModified(null, actionMessage.shiftsDeleted, null, store);
});